import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBasketShopping } from "@fortawesome/pro-regular-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  removeItemFromBasket,
  addItemToBasket,
  updateQuantity,
} from "../../features/basket/basketSlice";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import FieldError from "../../components/ui/FieldError";
import { toast } from "react-toastify";

const BasketButton = ({ item, className, size, isloading }) => {
  const form = useForm();
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.basket);
  const formSubmitBtn = useRef();
  const [quantity, setQuantity] = useState(null);
  const { t } = useTranslation();
  const purchaseOrderItem =
    (basket &&
      Array.isArray(basket.entities) &&
      basket.entities.find((i) => i.item.id === item.id)) ||
    null;

  const removeFromBasket = () => {
    dispatch(removeItemFromBasket(purchaseOrderItem)).then(() => {
      form.reset();
      setQuantity(null);
    });
  };

  const onSubmit = async (data) => {
    if (!quantity) return;

    dispatch(
      updateQuantity({
        purchaseOrderItem: purchaseOrderItem,
        quantity: parseInt(quantity),
      })
    ).then((e) => {
      if (
        e.payload.response?.status !== 200 &&
        e.payload.response?.data?.violations
      ) {
        e.payload.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      } else {
        form.reset();
        setQuantity(null);
        toast.success(t("items.quantityUpdated"), {
          theme: "colored",
          hideProgressBar: true,
          autoClose: 500,
        });
      }
    });
  };

  let timeout;
  useEffect(() => {
    if (quantity) {
      timeout = setTimeout(() => {
        formSubmitBtn.current.click();
      }, 350);
    }
    return () => clearTimeout(timeout);
  }, [quantity]);

  return (
    <div className="text-xs">
      {purchaseOrderItem ? (
        <div>
          <div
            className={`flex items-center ${
              className ? className : "justify-end"
            }`}
          >
            <button
              className={`${
                !isloading && "bg-bioport-orange hover:bg-bioport-orange-light"
              } duration-300 text-white ${
                size !== "xl" ? "h-10 w-10 lg:h-12 lg:w-12" : "p-4"
              } rounded-full justify-center cursor-pointer flex items-center`}
              onClick={() => removeFromBasket(item)}
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                className="text-md lg:text-lg"
                title={t("shop.removeBasket")}
              />
            </button>
            <form
              onSubmit={form.handleSubmit((data) => onSubmit(data))}
              autoComplete="off"
            >
              <input
                defaultValue={
                  basket.entities.find((i) => i.item.id === item.id).quantity
                }
                className="w-12 lg:w-20 ml-3 text-center text-xs rounded"
                type="text"
                autoFocus
                {...form.register("quantity")}
                onChange={(event) => setQuantity(event.target.value)}
                aria-invalid={form.formState?.errors?.quantity ? true : false}
                disabled={isloading}
              />

              <input type="submit" className="hidden" ref={formSubmitBtn} />
            </form>
          </div>
          <div className="text-center">
            <FieldError
              error={form.formState?.errors?.quantity}
              className="mb-0 pb-0 text-xs pt-4 mt-0"
            />
          </div>
        </div>
      ) : (
        <div className={`flex ${className}`}>
          <button
            className={`bg-gray-400 hover:bg-gray-500 duration-300 text-white ${
              size !== "xl" ? "h-10 w-10 lg:h-12 lg:w-12" : "p-4"
            } rounded-full justify-center cursor-pointer flex items-center`}
            onClick={() => dispatch(addItemToBasket(item["@id"]))}
          >
            <FontAwesomeIcon
              icon={faBasketShopping}
              className="text-sm lg:text-lg"
              title={t("shop.addBasket")}
            />
            {size === "xl" && (
              <div className="ml-3 font-bold text-md">
                {t("shop.basket.add")}
              </div>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default BasketButton;
